<template>
  <template-layout>
    <div class="intro-y flex flex-col sm:flex-row items-center my-8">
      <h1 class="text-lg font-medium mr-auto">จัดการข้อมูลผู้ใช้งาน</h1>
    </div>
    <div class="body intro-y box py-10">
      <!-- <div class="text-right pt-5 pr-5" v-if="editForm = false">
            <button class="btn btn-primary" @click="editForm = true">
                <Edit2Icon class="h-3 w-3 mr-1" />
                แก้ไข
            </button>
        </div> -->
      <div class="grid items-center justify-center align-center px-20 pt-10">
        <div class="h-32 w-32 rounded-full bg-theme-41 p-1 mb-2 flex-shrink-0 cursor-pointer">
          <div
            class="
              grid
              hover:opacity-70
              h-full
              w-full
              rounded-full
              bg-theme-33
              border-4 border-white
              content-center
              text-center
              relative
              overflow-hidden
            "
          >
            <label class="h-full w-full content-center text-center absolute cursor-pointer overflow-hidden rounded-full">
              <ImageIcon
                class="opacity-50 w-10 h-10 text-white"
                style="margin: 36px auto;"
                v-if="!imageUrl"
              />
              <div class="hover:opacity-70 w-full h-full">
                <img
                  class="object-center object-cover w-full h-full rounded-full"
                  v-if="imageUrl"
                  :src="imageUrl"
                />
              </div>
              <input
                @change="onEventFilePicked"
                type="file"
                name="upload"
                accept="image/*"
                class="hidden h-full w-full"
                data-test="image-input"
              />
            </label>
          </div>
        </div>
      </div>
      <div class="grid grid-cols-12 gap-x-4 gap-y-3 md:px-20 xs:px-5 pt-10">
        <div class="md:col-span-2 xs:col-span-12">
          <label class="form-label text-theme-98">
            คำนำหน้าชื่อ <span class="text-theme-5">*</span>
          </label>
          <v-select
            height="500"
            data-test="dropdown-user"
            id="dropdown-user"
            v-model="state.titleSelected"
            :options="title"
            label="label"
            :reduce="label => label.id"
            :clearable="false"
            placeholder="กรุณาเลือกคำนำหน้า"
          />

          <!-- <treeselect
            id="dropdown-user"
            v-model="state.titleSelected"
            noResultsText="ไม่พบข้อมูล"
            noOptionsText="ไม่พบข้อมูล"
            :options="title"
            placeholder="กรุณาเลือกคำนำหน้า"
            data-test="dropdown-staff"
            :clearable="false"
            :class="{ errorselect: v$.titleSelected.$errors.length }"
          /> -->
          <!-- :class="{ errorselect: v$.titleStaffSelected.$errors.length }"/> -->
          <div
            class="input-errors"
            v-for="error of v$.titleSelected.$errors"
            :key="error.$uid"
          >
            <div class="error-msg">{{ error.$message }}</div>
          </div>
        </div>
        <div
          class="md:col-span-4 xs:col-span-12"
          :class="{ error: v$.firstName.$errors.length }"
        >
          <label class="form-label text-theme-98">
            ชื่อ <span class="text-theme-5">*</span>
          </label>
          <input
            id="idcard-staff-input"
            type="text"
            class="form-control placeholder-theme-19"
            v-model="state.firstName"
            placeholder="กรุณากรอกชื่อ"
            data-test="idcard-staff-input"
          />
          <div
            class="input-errors"
            v-for="error of v$.firstName.$errors"
            :key="error.$uid"
          >
            <div class="error-msg">{{ error.$message }}</div>
          </div>
        </div>
        <div
          class="md:col-span-6 xs:col-span-12"
          :class="{ error: v$.lastName.$errors.length }"
        >
          <label class="form-label text-theme-98">
            นามสกุล <span class="text-theme-5">*</span>
          </label>
          <input
            id="idcard-staff-input"
            type="text"
            class="form-control placeholder-theme-19"
            v-model="state.lastName"
            placeholder="กรุณากรอกนามสกุล"
            data-test="idcard-staff-input"
          />
          <div
            class="input-errors"
            v-for="error of v$.lastName.$errors"
            :key="error.$uid"
          >
            <div class="error-msg">{{ error.$message }}</div>
          </div>
        </div>
        <div class="md:col-span-6 xs:col-span-12">
          <label class="form-label text-theme-98" for="dropdown-departmentCode">
            หน่วยงานระดับกรม <span class="text-theme-5">*</span>
          </label>
          <v-select
            data-test="dropdown-departmentCode"
            id="dropdown-departmentCode"
            v-model="state.departmentCode"
            :options="departmentOptions"
            item-value="AGC_CODE"
            item-text="AGC_NAME"
            label="AGC_NAME"
            :clearable="false"
            placeholder="กรุณาเลือกกรม"
            :class="{ errorselect: v$.departmentCode.$errors.length }"
            @option:selected="getSector"
          />
          <!-- <treeselect
            id="dropdown-user"
            v-model="state.departmentCode"
            noResultsText="ไม่พบข้อมูล"
            noOptionsText="ไม่พบข้อมูล"
            :options="departmentArr"
            placeholder="กรุณาเลือกกรม"
            data-test="dropdown-staff"
            :clearable="false"
            :class="{ errorselect: v$.departmentCode.$errors.length }"
            :normalizer="normalizerDepartment"
            @select="getSector"
          /> -->
          <div
            class="input-errors"
            v-for="error of v$.departmentCode.$errors"
            :key="error.$uid"
          >
            <div class="error-msg">{{ error.$message }}</div>
          </div>
        </div>
        <div class="md:col-span-6 xs:col-span-12">
          <label class="form-label text-theme-98" for="dropdown-sectorCode">
            หน่วยงาน <span class="text-theme-5">*</span>
          </label>
          <v-select
            data-test="dropdown-sectorCode"
            id="dropdown-sectorCode"
            v-model="state.sectorCode"
            :options="sectorOptions"
            item-value="ORG_CODE"
            item-text="ORG_NAME"
            label="ORG_NAME"
            :clearable="false"
            placeholder="กรุณาเลือกหน่วยงาน"
            :class="{ errorselect: v$.departmentCode.$errors.length }"
          />
          <!-- <treeselect
            id="dropdown-user"
            v-model="state.sectorCode"
            noResultsText="ไม่พบข้อมูล"
            noOptionsText="ไม่พบข้อมูล"
            :options="sectorArr"
            placeholder="กรุณาเลือกหน่วยงาน"
            data-test="dropdown-staff"
            :clearable="false"
            :normalizer="normalizerSector"
            :class="{ errorselect: v$.sectorCode.$errors.length }"
            @select="summarySector"
          /> -->
          <div
            class="input-errors"
            v-for="error of v$.sectorCode.$errors"
            :key="error.$uid"
          >
            <div class="error-msg">{{ error.$message }}</div>
          </div>
        </div>
        <div
          class="md:col-span-6 xs:col-span-12"
          :class="{ error: v$.position.$errors.length }"
        >
          <label class="form-label text-theme-98">
            ตำแหน่ง <span class="text-theme-5">*</span>
          </label>
          <input
            id="idcard-staff-input"
            type="text"
            class="form-control placeholder-theme-19"
            v-model="state.position"
            placeholder="กรุณากรอกตำแหน่ง"
            data-test="idcard-staff-input"
          />
          <div
            class="input-errors"
            v-for="error of v$.position.$errors"
            :key="error.$uid"
          >
            <div class="error-msg">{{ error.$message }}</div>
          </div>
        </div>
        <div
          class="md:col-span-6 xs:col-span-12"
          :class="{ error: v$.tel.$errors.length }"
        >
          <label class="form-label text-theme-98">
            เบอร์โทร <span class="text-theme-5">*</span>
          </label>
          <input
            id="idcard-staff-input"
            type="text"
            class="form-control placeholder-theme-19"
            v-model="state.tel"
            placeholder="กรุณากรอกเบอร์โทร"
            @input="onlyNumber"
            maxlength="10"
            data-test="idcard-staff-input"
          />
          <div
            class="input-errors"
            v-for="error of v$.tel.$errors"
            :key="error.$uid"
          >
            <div class="error-msg">{{ error.$message }}</div>
          </div>
        </div>
      </div>
      <div class="text-right pt-10 pr-5">
        <button class="btn btn-outline-secondary w-15 mr-1" @click="cancel">ยกเลิก</button>
        <button class="btn btn-primary w-15" @click="saveData">บันทึก</button>
      </div>
    </div>
    <!-- ThaID Account Linking Section -->
    <div class="intro-y box py-8 mt-5">
      <div class="md:px-20 xs:px-5">
        <h2 class="text-base font-medium mb-5">เชื่อมบัญชี ThaID</h2>
        <div class="border rounded-md p-5">
          <!-- Loading state -->
          <div v-if="thaidLinkLoading" class="flex items-center text-gray-500">
            <LoaderIcon class="w-4 h-4 mr-2 animate-spin" />
            กำลังตรวจสอบสถานะ...
          </div>

          <!-- Linked state -->
          <div v-else-if="isThaidLinked" class="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <div class="flex items-center">
              <CheckCircleIcon class="w-5 h-5 text-green-600 mr-2 flex-shrink-0" />
              <div>
                <p class="font-medium text-green-700">เชื่อมบัญชี ThaID แล้ว</p>
                <p class="text-sm text-gray-500 mt-1" v-if="thaidProviderUserId">
                  บัญชี: {{ thaidProviderUserId }}
                </p>
              </div>
            </div>
            <button
              class="btn btn-outline-danger btn-sm"
              @click="handleUnlinkThaid"
              :disabled="thaidActionLoading"
            >
              <LoaderIcon v-if="thaidActionLoading" class="w-3 h-3 mr-1 animate-spin" />
              ยกเลิกการเชื่อม
            </button>
          </div>

          <!-- Not linked state -->
          <div v-else class="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <div class="flex items-center">
              <AlertCircleIcon class="w-5 h-5 text-gray-400 mr-2 flex-shrink-0" />
              <div>
                <p class="font-medium text-gray-700">ยังไม่ได้เชื่อมบัญชี ThaID</p>
                <p class="text-sm text-gray-500 mt-1">
                  เชื่อมบัญชี ThaID เพื่อให้สามารถเข้าสู่ระบบด้วย ThaID ได้
                </p>
              </div>
            </div>
            <button
              class="btn btn-primary btn-sm"
              @click="handleLinkThaid"
              :disabled="thaidActionLoading"
            >
              <LoaderIcon v-if="thaidActionLoading" class="w-3 h-3 mr-1 animate-spin" />
              เชื่อมบัญชี ThaID
            </button>
          </div>
        </div>
      </div>
      <!-- Google Authenticator Linking Section -->
      <div class="md:px-20 xs:px-5 mt-5">
        <h2 class="text-base font-medium mb-5">เชื่อมบัญชี Google Authenticator</h2>
        <div class="border rounded-md p-5">
          <!-- Linked state -->
          <div
            v-if="googleAuthenEmail"
            class="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4"
          >
            <div class="flex items-center">
              <CheckCircleIcon class="w-5 h-5 text-green-600 mr-2 flex-shrink-0" />
              <div>
                <p class="font-medium text-green-700">เชื่อมบัญชี Google Authenticator แล้ว</p>
                <p class="text-sm text-gray-500 mt-1">
                  บัญชี: {{ googleAuthenEmail }}
                </p>
              </div>
            </div>
            <button
              class="btn btn-outline-danger btn-sm"
              @click="handleUnlinkGoogleAuthen"
              :disabled="googleActionLoading"
            >
              <LoaderIcon
                v-if="googleActionLoading"
                class="w-3 h-3 mr-1 animate-spin"
              />
              ยกเลิกการเชื่อม
            </button>
          </div>

          <!-- Not linked state -->
          <div
            v-else
            class="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4"
          >
            <div class="flex items-center">
              <AlertCircleIcon class="w-5 h-5 text-gray-400 mr-2 flex-shrink-0" />
              <div>
                <p class="font-medium text-gray-700">
                  ยังไม่ได้เชื่อมบัญชี Google Authenticator
                </p>
                <p class="text-sm text-gray-500 mt-1">
                  เชื่อมบัญชี Google Authenticator เพื่อเพิ่มความปลอดภัยในการเข้าสู่ระบบ
                </p>
              </div>
            </div>
            <button
              class="btn btn-primary btn-sm"
              @click="handleLinkGoogleAuthen"
              :disabled="googleActionLoading"
            >
              <LoaderIcon
                v-if="googleActionLoading"
                class="w-3 h-3 mr-1 animate-spin"
              />
              เชื่อมบัญชี Google Authenticator
            </button>
          </div>
        </div>
      </div>
    </div>
  </template-layout>
</template>

<script setup>
import Swal from "sweetalert2";
import TemplateLayout from "@/layouts/side-menu/Main.vue";
import "vue3-treeselect/dist/vue3-treeselect.css";
import useVuelidate from "@vuelidate/core";
import { ref, reactive, watch, computed, onMounted } from "vue";
import { required, helpers, minLength, maxLength } from "@vuelidate/validators";
import axios from "axios";
import store from "@/store";
import { uploadfile } from "@/utils/minio.js";
import getUserInfo from "@/utils/get-user-info.js";
import { checkThaidLinkStatus, linkThaid, unlinkThaid } from "@/utils/thaid-link.js";
import REF_MSO_AGC from "@/data/REF_MSO_AGC.json";
import REF_MSO_ORG from "@/data/REF_MSO_ORG.json";
const LOCAL_REF_MSO_AGC = structuredClone(REF_MSO_AGC);
const LOCAL_REF_MSO_ORG = structuredClone(REF_MSO_ORG);

const swalCustom = Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-primary m-1',
    cancelButton: 'btn btn-outline-secondary m-1'
  },
  buttonsStyling: false
})

const imageUrl = ref("");
const departmentArr = ref([]);
const sectorArr = ref([]);
const departmentName = ref();
const sectorName = ref("");

const departmentOptions = ref([]);
const sectorOptions = ref([]);

const title = reactive([
  { id: "นาย", label: "นาย" },
  { id: "นาง", label: "นาง" },
  { id: "นางสาว", label: "นางสาว" },
]);
const defaultArr = reactive([
  {
    AGC_CODE: null,
    AGC_NAME: null,
    ORG_CODE: null,
    ORG_NAME: null,
  },
]);
const state = reactive({
  id: null,
  titleSelected: null,
  firstName: null,
  lastName: null,
  position: null,
  departmentCode: null,
  sectorCode: null,
  tel: null,
});
const imageFile = ref(null)
const tempImage = ref(null)
const rules = {
  titleSelected: {
    required: helpers.withMessage("กรุณาเลือกคำนำหน้า", required),
  },
  firstName: { required: helpers.withMessage("กรุณากรอกชื่อ", required) },
  lastName: { required: helpers.withMessage("กรุณากรอกนามสกุล", required) },
  position: { required: helpers.withMessage("กรุณากรอกตำแหน่ง", required) },
  departmentCode: { required: helpers.withMessage("กรุณาเลือกกรม", required) },
  sectorCode: { required: helpers.withMessage("กรุณาเลือกหน่วยงาน", required) },
  tel: {
    required: helpers.withMessage("กรุณากรอกเบอร์โทรศัพท์มือถือ", required),
    minLength: helpers.withMessage(
      "กรุณากรอกเบอร์โทรศัพท์มือถือ",
      minLength(10)
    ),
    maxLength: helpers.withMessage(
      "กรุณากรอกเบอร์โทรศัพท์มือถือ",
      maxLength(10)
    ),
  },
};

// ─── ThaID Linking ─────────────────────────────────────────
const thaidLinkLoading = ref(true);
const thaidActionLoading = ref(false);
const isThaidLinked = computed(() => store.getters["userAuth/getIsThaidLinked"]);
const thaidProviderUserId = computed(() => store.getters["userAuth/getThaidProviderUserId"]);

// Google Authenticator linking state
const googleActionLoading = ref(false);
const googleAuthenEmail = computed(
  () => "test@gmail.com" // TODO: store.getters["userAuth/getGoogleAuthenEmail"]
);
const refreshThaidStatus = async () => {
  thaidLinkLoading.value = true;
  try {
    const status = await checkThaidLinkStatus();
    store.dispatch("userAuth/setThaidLinkStatus", status);
  } catch (err) {
    if (process.env.VUE_APP_ENV !== "production") console.log("[ThaID] status check error:", err.message);
  } finally {
    thaidLinkLoading.value = false;
  }
};

const handleLinkThaid = async () => {
  thaidActionLoading.value = true;
  try {
    await linkThaid();
    // Browser จะ redirect ไป Keycloak → ThaID → กลับมา App
    // App reload → checkThaidLinkStatus() จะอัพเดทสถานะเอง
  } catch (err) {
    thaidActionLoading.value = false;
    const msg = err.message || "ไม่สามารถเชื่อมบัญชี ThaID ได้ กรุณาลองใหม่อีกครั้ง";
    swalCustom.fire({
      text: msg,
      icon: "warning",
      confirmButtonText: "ปิด",
    });
  }
};

// ─── Google Authenticator Linking (UI only for now) ────────────
const handleLinkGoogleAuthen = async () => {
  googleActionLoading.value = true;
  try {
    await swalCustom.fire({
      icon: "info",
      title: "อยู่ระหว่างการพัฒนา",
      text: "ฟีเจอร์เชื่อมบัญชี Google Authenticator จะพร้อมใช้งานในภายหลัง",
      confirmButtonText: "ปิด",
    });
  } finally {
    googleActionLoading.value = false;
  }
};

const handleUnlinkGoogleAuthen = async () => {
  googleActionLoading.value = true;
  try {
    await swalCustom.fire({
      icon: "info",
      title: "อยู่ระหว่างการพัฒนา",
      text: "ฟีเจอร์ยกเลิกการเชื่อมบัญชี Google Authenticator จะพร้อมใช้งานในภายหลัง",
      confirmButtonText: "ปิด",
    });
  } finally {
    googleActionLoading.value = false;
  }
};

const handleUnlinkThaid = async () => {
  const result = await swalCustom.fire({
    text: "ต้องการยกเลิกการเชื่อมบัญชี ThaID หรือไม่? หลังยกเลิกแล้วจะไม่สามารถเข้าสู่ระบบด้วย ThaID ได้",
    icon: "warning",
    showCancelButton: true,
    reverseButtons: true,
    cancelButtonText: "ยกเลิก",
    confirmButtonText: "ยืนยัน",
    allowOutsideClick: false,
  });

  if (!result.isConfirmed) return;

  thaidActionLoading.value = true;
  try {
    await unlinkThaid();
    store.dispatch("userAuth/setThaidLinkStatus", { linked: false, providerUserId: null });
    swalCustom.fire({
      text: "ยกเลิกการเชื่อมบัญชี ThaID สำเร็จ",
      icon: "success",
      timer: 3000,
      confirmButtonText: "ปิด",
    });
  } catch (err) {
    swalCustom.fire({
      text: "ไม่สามารถยกเลิกการเชื่อมได้ กรุณาลองใหม่อีกครั้ง",
      icon: "warning",
      confirmButtonText: "ปิด",
    });
  } finally {
    thaidActionLoading.value = false;
  }
};

onMounted(() => {
  getDepartmentOptions();
  getProfileData();
  refreshThaidStatus();
});

const getProfileData = async () => {
  try {
    let userName = store.getters["userAuth/getUsername"];
    await axios
      .post(`${process.env.VUE_APP_BASE_API}user/getUser`, { uid: userName })
      .then((res) => {
        if (res.status === 200) {
          if (res.data.length > 0) {
            const readData = res.data[res.data.length - 1];
            state.id = readData._id;
            state.titleSelected = readData.title;
            state.firstName = readData.name;
            state.lastName = readData.surname;
            state.position = readData.position;
            state.departmentCode = {
              AGC_CODE: readData.organization.agc_code,
              AGC_NAME: readData.organization.agc_name,
            };
            state.tel = readData.tel_num;
            imageUrl.value = readData.profile_images ? readData.profile_images.img_url : null

            getSector({
              AGC_CODE: readData.organization.agc_code,
              AGC_NAME: readData.organization.agc_name,
            });
            state.sectorCode = {
              ORG_CODE: readData.organization.org_code,
              ORG_NAME: readData.organization.org_name,
            };
          }
        } else {
          swalCustom.fire({
            text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
            icon: "warning",
            //timer: 3000, //timeOut for auto-close
            confirmButtonText: "ปิด",
          });
        }
      });
  } catch (error) {
    console.log(error.message);
  }
};

const getDepartmentOptions = () => {
    changeDepartment();
    manageDataDepartment(LOCAL_REF_MSO_AGC);
};
const getSector = (department_data) => {
  changeDepartment();
  departmentName.value = department_data.AGC_NAME;
  manageDataSector(LOCAL_REF_MSO_ORG);
};
function manageDataDepartment(Data) {
  departmentOptions.value = Data.sort((a, b) =>
    a.AGC_NAME > b.AGC_NAME ? 1 : -1
  );
  //state.departmentCode = {AGC_CODE: 6301, AGC_NAME: "กรมพัฒนาสังคมและสวัสดิการ"};
}
function manageDataSector(Data) {
  const tempSectorArr = Data.filter(
    (name) => name.AGC_NAME === departmentName.value
  );
  sectorOptions.value = tempSectorArr.sort((a, b) =>
    a.ORG_NAME > b.ORG_NAME ? 1 : -1
  );
}

const cancel = () => {
  window.history.go(-1);
};
const changeDepartment = () => {
  if (sectorOptions.value.length != 0) {
    sectorOptions.value = [];
    state.sectorCode = null;
  }
};
const summarySector = (sector_data) => {
  sectorName.value = sector_data.ORG_NAME;
};
const onlyNumber = () => {
  state.tel = state.tel.replace(/[^\d]/g, "");
};
const onEventFilePicked = (event) => {
  const files = event.target.files;
  const fileReader = new FileReader();
  if(files.length > 0){
    tempImage.value = files[0]
    imageFile.value = files[0]
  }
  else{
    imageFile.value = tempImage.value
  }
  fileReader.addEventListener("load", (event) => {
    imageUrl.value = fileReader.result;
  });
  fileReader.readAsDataURL(files[0]);
};
const v$ = useVuelidate(rules, state);
const revertImageOnUploadFail = () => {
  // ดึงข้อมูล Profile ล่าสุดกลับมา เพื่อให้ imageUrl.value ถูกกำหนดจากข้อมูลใน DB ก่อนการอัปโหลด
  getProfileData();
  // ล้างค่าไฟล์ที่ถูกเลือกไว้
  imageFile.value = null; 
  tempImage.value = null;
  // รีเซ็ตค่าใน input type="file" (จำเป็นสำหรับ browser บางตัว) เพื่อไม่ให้ไฟล์เดิมติดค้างอยู่
  const inputElement = document.querySelector('input[type="file"][data-test="image-input"]');
  if (inputElement) {
    inputElement.value = '';
  }
};
const saveData = async () => {
  const isFormCorrect = await v$.value.$validate();

  if (isFormCorrect) {
    swalCustom.fire({
      text:"ยืนยันบันทึกข้อมูล",
      icon:"info",
      showCancelButton: true,
      reverseButtons: true,
      cancelButtonText: "ยกเลิก",
      confirmButtonText: "ตกลง",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        sentApi().then(() => {
          store.dispatch("userInfo/clearStore");
          getUserInfo();
        });
      }
    });
  }
};
const sentApi = async () => {
  let userName = store.getters["userAuth/getUsername"];

  let reqData = {
    uid: userName,
    title: state.titleSelected,
    name: state.firstName,
    surname: state.lastName,
    position: state.position,
    organization: {
      agc_code: String(state.departmentCode.AGC_CODE),
      agc_name: state.departmentCode.AGC_NAME,
      org_code: String(state.sectorCode.ORG_CODE),
      org_name: state.sectorCode.ORG_NAME,
    },
    tel_num: state.tel,
    province_code: store.getters["userAuth/getTokenParsed"].provinceCode,
    province_name: store.getters["userAuth/getTokenParsed"].provinceName,

  };
  if (typeof state.id == "string") {
    if(imageFile.value){
      const result = await uploadfile(
        imageFile.value,
        `images/user/${state.id}`,
        `profile-image-${state.id}`
      ).catch(() => {
        swalCustom.fire({
            icon: "warning",
            text: `บันทึกไฟล์รูปภาพไม่สำเร็จ`,
            // text: `บันทึกไฟล์ ${imageFile.value.name} ไม่สำเร็จ`,
            confirmButtonText: "ปิด",
        });
        return;
      });
      if (result.res.status === 200) {
        const image = {
            "img_label": "ภาพถ่าย",
            "file_name": result.file_name,
            "img_url": result.url,
            "created_date": new Date().toISOString()
        }
        reqData.profile_images = image
      }else if(result.res.response.status === 503){
 swalCustom.fire({
            icon: "warning",
            text: `บันทึกไฟล์รูปภาพไม่สำเร็จ`,
            // text: `บันทึกไฟล์ ${imageFile.value.name} ไม่สำเร็จ`,
            confirmButtonText: "ปิด",
        }).then(() => {
            revertImageOnUploadFail();
        });
        return;
      }
    }

    await axios
      .put(`${process.env.VUE_APP_BASE_API}user/${state.id}`, {
        update: reqData,
      },
      {
        headers: {
            Authorization: `Bearer ${store.getters["userAuth/getToken"]}`,
            "Content-Type": `application/json; charset=utf-8`,
        }
      })
      .then((res) => {
        if (res.status === 200) {
          swalCustom.fire({
            text:"สำเร็จ",
            icon: 'success',
            timer: 3000,
            confirmButtonText: "ปิด",
          }).then(function () {
            // location.reload();
            getProfileData()
          });
        } else {
          swalCustom.fire({
            text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
            icon: "warning",
            //timer: 3000, //timeOut for auto-close
            confirmButtonText: "ปิด",
          });
        }
      })
      .catch(()=>{
        swalCustom.fire({
          text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
          icon: "warning",
          //timer: 3000, //timeOut for auto-close
          confirmButtonText: "ปิด",
        });
      });
  } else {
    await axios
      .post(`${process.env.VUE_APP_BASE_API}user/`, {
        doc: reqData,
      },
      {
        headers: {
            Authorization: `Bearer ${store.getters["userAuth/getToken"]}`,
            "Content-Type": `application/json; charset=utf-8`,
        }
      })
      .then(async(res) => {
        if (res.status === 200) {
          if(imageFile.value && res.data.insertedId){
            const result = await uploadfile(
              imageFile.value,
              `images/user/${res.data.insertedId}`,
              `profile-image-${res.data.insertedId}`
            ).catch(() => {
              swalCustom.fire({
                  icon: "warning",
            text: `บันทึกไฟล์รูปภาพไม่สำเร็จ`,
                  // text: `บันทึกไฟล์ ${imageFile.value.name} ไม่สำเร็จ`,
                  confirmButtonText: "ปิด",
              });
        return;
            });
            if (result.res.status === 200) {
              const image = {
                "img_label": "ภาพถ่าย",
                "file_name": result.file_name,
                "img_url": result.url,
                "created_date": new Date().toISOString()
              }
              //update only image
              await axios
              .put(`${process.env.VUE_APP_BASE_API}user/${res.data.insertedId}`, {
                update: {"profile_images":image},
              },
              {
                headers: {
                    Authorization: `Bearer ${store.getters["userAuth/getToken"]}`,
                    "Content-Type": `application/json; charset=utf-8`,
                }
              })
              .then((res_update) => {
                if (res_update.status === 200) {
                  swalCustom.fire({
                    text:"สำเร็จ",
                    icon: 'success',
                    timer: 3000,
                    confirmButtonText: "ปิด",
                  }).then(function () {
                    // location.reload();
                    getProfileData()
                  });
                } else {
                  swalCustom.fire({
                    text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
                    icon: "warning",
                    //timer: 3000, //timeOut for auto-close
                    confirmButtonText: "ปิด",
                  });
                }
              })
              .catch(()=>{
                swalCustom.fire({
                  text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
                  icon: "warning",
                  //timer: 3000, //timeOut for auto-close
                  confirmButtonText: "ปิด",
                });
              });
            }else if(result.res.response.status === 503){
swalCustom.fire({
                  icon: "warning",
            text: `บันทึกไฟล์รูปภาพไม่สำเร็จ`,
                  // text: `บันทึกไฟล์ ${imageFile.value.name} ไม่สำเร็จ`,
                  confirmButtonText: "ปิด",
              }).then(() => {
            revertImageOnUploadFail();
        });
        return;
      }
          }else{
            swalCustom.fire({
              text:"สำเร็จ",
              icon: 'success',
              timer: 3000,
              confirmButtonText: "ปิด",
            }).then(function () {
              // location.reload();
              getProfileData()
            });
          }
        } else {
          swalCustom.fire({
            text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
            icon: "warning",
            //timer: 3000, //timeOut for auto-close
            confirmButtonText: "ปิด",
          });
        }
      });
  }
};
</script>

<style>
.vs__dropdown-toggle {
  height: 2.4rem !important;
}
</style>